import extendNode from '../extendNode.mjs'
import useAbstractNode from '../_ABSTRACT/useAbstractNode.jsx'
import meta from './metaDbins_.mjs'
import FormChoose from '../DBINS/FormChooseDbins.jsx'
import TableChoose from '../DBINS/TableChooseDbins.jsx'
import api from './apiDbins_.mjs'

export default () => {
    const AbstractNode = useAbstractNode()

    return extendNode(AbstractNode, {
        ...meta,
        api,
        FormChoose,
        TableChoose,
    })
}
